export default "__VITE_ASSET__DjQ_8mbH__"